import type { IAccessTokenProvider } from "../../application/interfaces/IAccessTokenProvider";
import type { IAppConfigProvider } from "../../application/interfaces/IAppConfigProvider";
import type { VideoCollectionDto } from "../../shared/VideoCollectionDto";
import type { IVideoRepository } from "../../application/interfaces/IVideoRepository";

export class VideoRepository implements IVideoRepository {
  readonly configProvider: IAppConfigProvider;
  readonly tokenProvider: IAccessTokenProvider;

  // Caching Results
  datastore:VideoCollectionDto[]|null = null

  constructor(
    configProvider: IAppConfigProvider,
    tokenProvider: IAccessTokenProvider,
  ) {
    this.configProvider = configProvider;
    this.tokenProvider = tokenProvider;
  }

  async getAll(): Promise<VideoCollectionDto[]> {
    if (this.datastore != null){
      return this.datastore;
    }
    const token = await this.tokenProvider.getAccessToken();
    const config = await this.configProvider.getAppConfig();
    const headers: Record<string, string> = {
      "X-Api-Key": config.apiKey,
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    const url = `${config.apiUrl}/Video`;
    const response = await fetch(url, {
      headers,
    });
    if (response.ok){
      let results = (await response.json()) as VideoCollectionDto[];
      this.datastore = results
      return this.datastore;
    } else {
      if (response.status == 401){
        await this.tokenProvider.clearToken();
      }
      return []
    }
  }
}
